export var Orders = [
    {
        "PromoCode": "test",
        "PurchaseOrderNumber": "test",
        "IsPartialDelivery": true,
        "IsBillingAddressSame": true,
        "Items": [
            {
                "Description": "150 FC REBUILD ",
                "PartNumber": "S/N9115001     ",
                "DrawingNum": "",
                "Uom   ": "EA",
                "Qty": 1
            }
        ],
        "QuestionComment": "test",
        "CourierName": "FEDEX",
        "OtherCourierName": "",
        "CourierAccountNumber": "test",
        "DeliveryMethod": "Ground shipping",
        "Brand": {
            "Id": "9120e71c-45bd-47d9-8d45-f53c2f2962b6",
            "Name": "Premier Tech",
            "Order": 1,
            "CreatedDate": null,
            "CreatedBy": null,
            "ModifiedDate": null,
            "ModifiedBy": null
        },
        "ShippingMethod": "other",
        "Status": {
            "Id": "",
            "Name": ""
        },
        "ShippingAddress": {
            "Line": "1",
            "City": "1",
            "Country": {
                "Id": "194a4597-c196-4a0b-b43e-cb53be4e610c",
                "ShortName": "AW",
                "Name": "Aruba"
            },
            "StateProvince": "1",
            "PostalCode": "1",
            "TypeId": null,
            "AccountId": null
        },
        "BillingAddress": {
            "Line": "1",
            "City": "1",
            "Country": {
                "Id": "194a4597-c196-4a0b-b43e-cb53be4e610c",
                "ShortName": "AW",
                "Name": "Aruba"
            },
            "StateProvince": "1",
            "PostalCode": "1",
            "TypeId": null,
            "AccountId": null
        },
        "Contact": {
            "FirstName": "Sebastien",
            "LastName": "Lemieux",
            "JobTitle": "test",
            "Phone": "4185511621",
            "Email": "lems3@premiertech.com",
            "AccountId": null,
            "CompanyName": "test23"
        },
        "id": "0b1c76d5-a9fc-4f41-a0dc-a9fcd71576ds",
        "orderType": "order"
    },
    {
        "PromoCode": "test",
        "PurchaseOrderNumber": "test",
        "IsPartialDelivery": true,
        "IsBillingAddressSame": true,
        "Items": [
            {
                "Description": "150 FC REBUILD                ",
                "PartNumber": "S/N9115001     ",
                "DrawingNum": "",
                "Uom   ": "EA",
                "Qty": 1
            }
        ],
        "QuestionComment": "test",
        "CourierName": "FEDEX",
        "OtherCourierName": "",
        "CourierAccountNumber": "test",
        "DeliveryMethod": "Ground shipping",
        "Brand": {
            "Id": "9120e71c-45bd-47d9-8d45-f53c2f123456",
            "Name": "Premier Tech",
            "Order": 1,
            "CreatedDate": null,
            "CreatedBy": null,
            "ModifiedDate": null,
            "ModifiedBy": null
        },
        "ShippingMethod": "other",
        "Status": {
            "Id": "",
            "Name": ""
        },
        "ShippingAddress": {
            "Line": "1",
            "City": "1",
            "Country": {
                "Id": "194a4597-b43e-4a0b-b43e-cb5194a45979",
                "ShortName": "AW",
                "Name": "Aruba"
            },
            "StateProvince": "1",
            "PostalCode": "1",
            "TypeId": null,
            "AccountId": null
        },
        "BillingAddress": {
            "Line": "1",
            "City": "1",
            "Country": {
                "Id": "194a4597-5a9e-4a0b-b43e-521v95a96q3v",
                "ShortName": "AW",
                "Name": "Aruba"
            },
            "StateProvince": "1",
            "PostalCode": "1",
            "TypeId": null,
            "AccountId": null
        },
        "Contact": {
            "FirstName": "Sebastien",
            "LastName": "Lemieux",
            "JobTitle": "test",
            "Phone": "4185511621",
            "Email": "lems3@premiertech.com",
            "AccountId": null,
            "CompanyName": "test23"
        },
        "id": "0b1c76d5-a9fc-4f41-a0dc-2b73d7156fa1",
        "orderType": "order"
    },
    {
        "PromoCode": "test",
        "PurchaseOrderNumber": "test",
        "IsPartialDelivery": true,
        "IsBillingAddressSame": true,
        "Items": [
            {
                "Description": "150 FC REBUILD                ",
                "PartNumber": "S/N9115001     ",
                "DrawingNum": "",
                "Uom   ": "EA",
                "Qty": 1
            }
        ],
        "QuestionComment": "test",
        "CourierName": "FEDEX",
        "OtherCourierName": "",
        "CourierAccountNumber": "test",
        "DeliveryMethod": "Ground shipping",
        "Brand": {
            "Id": "9120e71c-45bd-47d9-8d45-f53c2f2962b6",
            "Name": "Premier Tech",
            "Order": 1,
            "CreatedDate": null,
            "CreatedBy": null,
            "ModifiedDate": null,
            "ModifiedBy": null
        },
        "ShippingMethod": "other",
        "Status": {
            "Id": "",
            "Name": ""
        },
        "ShippingAddress": {
            "Line": "1",
            "City": "1",
            "Country": {
                "Id": "194a4597-c196-4a0b-b43e-cb53be4e610c",
                "ShortName": "AW",
                "Name": "Aruba"
            },
            "StateProvince": "1",
            "PostalCode": "1",
            "TypeId": null,
            "AccountId": null
        },
        "BillingAddress": {
            "Line": "1",
            "City": "1",
            "Country": {
                "Id": "194a4597-c196-4a0b-b43e-cb53be4e610c",
                "ShortName": "AW",
                "Name": "Aruba"
            },
            "StateProvince": "1",
            "PostalCode": "1",
            "TypeId": null,
            "AccountId": null
        },
        "Contact": {
            "FirstName": "Sougnalo",
            "LastName": "Traore",
            "JobTitle": "test",
            "Phone": "4180001234",
            "Email": "tras2@premiertech.com",
            "AccountId": null,
            "CompanyName": "PT"
        },
        "id": "0b1c76d5-a9fc-qz5tp0-b1c7-qz5tp0156fa1",
        "orderType": "order"
    },
    {
        "PromoCode": "test",
        "PurchaseOrderNumber": "test",
        "IsPartialDelivery": true,
        "IsBillingAddressSame": true,
        "Items": [
            {
                "Description": "150 FC REBUILD                ",
                "PartNumber": "S/N9115001     ",
                "DrawingNum": "",
                "Uom   ": "EA",
                "Qty": 1
            }
        ],
        "QuestionComment": "test",
        "CourierName": "FEDEX",
        "OtherCourierName": "",
        "CourierAccountNumber": "test",
        "DeliveryMethod": "Ground shipping",
        "Brand": {
            "Id": "9120e71c-45bd-47d9-8d45-f53c2f2962b6",
            "Name": "Premier Tech",
            "Order": 1,
            "CreatedDate": null,
            "CreatedBy": null,
            "ModifiedDate": null,
            "ModifiedBy": null
        },
        "ShippingMethod": "other",
        "Status": {
            "Id": "",
            "Name": ""
        },
        "ShippingAddress": {
            "Line": "1",
            "City": "1",
            "Country": {
                "Id": "194a4597-c196-4a0b-b43e-cb53be4e610c",
                "ShortName": "AW",
                "Name": "Aruba"
            },
            "StateProvince": "1",
            "PostalCode": "1",
            "TypeId": null,
            "AccountId": null
        },
        "BillingAddress": {
            "Line": "1",
            "City": "1",
            "Country": {
                "Id": "194a4597-c196-4a0b-b43e-cb53be4e610c",
                "ShortName": "AW",
                "Name": "Aruba"
            },
            "StateProvince": "1",
            "PostalCode": "1",
            "TypeId": null,
            "AccountId": null
        },
        "Contact": {
            "FirstName": "Soungalo",
            "LastName": "Traore",
            "JobTitle": "test",
            "Phone": "4185511621",
            "Email": "tras2@premiertech.com",
            "AccountId": null,
            "CompanyName": "PT"
        },
        "id": "z8cn8pl-a9fc-4z8c-q4az-q4az8cn8pl45",
        "orderType": "order"
    },
    {
        "PromoCode": "",
        "PurchaseOrderNumber": null,
        "IsPartialDelivery": false,
        "IsBillingAddressSame": true,
        "Items": [{
                "Description": "REACTOR 3%Z 14A TCI           ",
                "PartNumber": "02150377            ",
                "DrawingNum": "",
                "Uom": "EA ",
                "Qty": 1,
                "Note": "test"
            }],
        "QuestionComment": "test",
        "CourierName": "",
        "OtherCourierName": "",
        "CourierAccountNumber": "",
        "DeliveryMethod": "",
        "Brand": {
            "Id": "563834b9-689f-476f-a4a1-58923485d9ca",
            "Name": "Stonepak",
            "Order": 2,
            "CreatedDate": null,
            "CreatedBy": null,
            "ModifiedDate": null,
            "ModifiedBy": null
        },
        "ShippingMethod": "",
        "Status": {
            "Id": "",
            "Name": ""
        },
        "ShippingAddress": {
            "Line": "Riviere-du-Loup",
            "City": "Riviere-du-Loup",
            "Country": {
                "Id": "8b8b29a8-0e25-40fa-9004-8482c49daa5f",
                "ShortName": "CA",
                "Name": "Canada"
            },
            "StateProvince": "Qc",
            "PostalCode": "G5R1B5",
            "TypeId": null,
            "AccountId": null
        },
        "BillingAddress": {
            "Line": "Riviere-du-Loup",
            "City": "Riviere-du-Loup",
            "Country": {
                "Id": "8b8b29a8-0e25-40fa-9004-8482c49daa5f",
                "ShortName": "CA",
                "Name": "Canada"
            },
            "StateProvince": "Qc",
            "PostalCode": "G5R1B5",
            "TypeId": null,
            "AccountId": null
        },
        "Contact": {
            "FirstName": "Sebastien",
            "LastName": "Lemieux",
            "JobTitle": "Développeur",
            "Phone": "4185511621",
            "Email": "lems3@premiertech.com",
            "AccountId": null,
            "CompanyName": "Premier Tech"
        },
        "orderType": "quote",
        "id": "10x2fg2s-2fg9-4f41-2fg9-10x2fg9osd71",
    },
    {
        "PromoCode": "",
        "PurchaseOrderNumber": null,
        "IsPartialDelivery": false,
        "IsBillingAddressSame": true,
        "Items": [{
                "Description": "REACTOR 3%Z 14A TCI           ",
                "PartNumber": "02150377            ",
                "DrawingNum": "",
                "Uom": "EA ",
                "Qty": 1,
                "Note": "test"
            }],
        "QuestionComment": "test",
        "CourierName": "",
        "OtherCourierName": "",
        "CourierAccountNumber": "",
        "DeliveryMethod": "",
        "Brand": {
            "Id": "563834b9-689f-476f-a4a1-58923485d9ca",
            "Name": "Stonepak",
            "Order": 2,
            "CreatedDate": null,
            "CreatedBy": null,
            "ModifiedDate": null,
            "ModifiedBy": null
        },
        "ShippingMethod": "",
        "Status": {
            "Id": "",
            "Name": ""
        },
        "ShippingAddress": {
            "Line": "_",
            "City": "Riviere-du-Loup",
            "Country": {
                "Id": "8b8b29a8-0e25-40fa-9004-8482c49daa5f",
                "ShortName": "CA",
                "Name": "Canada"
            },
            "StateProvince": "Qc",
            "PostalCode": "g0L2p0",
            "TypeId": null,
            "AccountId": null
        },
        "BillingAddress": {
            "Line": "4 saint-marc",
            "City": "Riviere-du-Loup",
            "Country": {
                "Id": "8b8b29a8-0e25-40fa-9004-8482c49daa5f",
                "ShortName": "CA",
                "Name": "Canada"
            },
            "StateProvince": "Qc",
            "PostalCode": "G5R1B5",
            "TypeId": null,
            "AccountId": null
        },
        "Contact": {
            "FirstName": "Soungalo",
            "LastName": "Traore",
            "JobTitle": "Dev",
            "Phone": "4180001234",
            "Email": "tras2@premiertech.com",
            "AccountId": null,
            "CompanyName": "Premier Tech"
        },
        "orderType": "quote",
        "id": "121dfs-a9fc-s85d-a0dc-0a5s85d69e09",
    }
];
//# sourceMappingURL=order-fake-data.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/DB/order-fake-data.js
// module id = 1156
// module chunks = 0